import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SmartphoneSVG = function SmartphoneSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M23 1H9a2 2 0 00-2 2v26a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm-8 2h2a1 1 0 010 2h-2a1 1 0 010-2zm-3 0a1 1 0 11-1 1 1 1 0 011-1zm3 25a1 1 0 111 1 1 1 0 01-1-1zm8-3H9V7h14z"
  }));
};
SmartphoneSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SmartphoneSVG);